
export default {
	name: 'PrivacyPolicy',
	head ()
	{
		if (this.$route.path === '/') return {};

		const baseUrl = 'https://enifex.com';

		const breadcrumbData = {
			"@context": "https://schema.org",
			"@type": "BreadcrumbList",
			"itemListElement": [
			{
				"@type": "ListItem",
				"position": 1,
				"name": "Home",
				"item": baseUrl
			},
			{
				"@type": "ListItem",
				"position": 2,
				"name": "Privacy Policy",
				"item": `${baseUrl}/privacy-policy`
			}
			]
		};
		return {
			title: 'Enifex - Privacy Policy',
			link: [
				{
					rel: 'canonical',
					href: `https://www.enifex.com${this.$route.path}`
				}
			],
			script: [
				{
					hid: 'schema-privacy-breadcrumb',
					type: 'application/ld+json',
					innerHTML: JSON.stringify(breadcrumbData)
				}
			]
		};
	},
}
